import { Liquor } from '@mui/icons-material';
import { Box, Typography } from '@mui/material';
import { FieldValue } from 'firebase/firestore';
import { useCallback, useState } from 'react';
import { useForm } from 'react-hook-form';
import { Order, OrderItem } from '../../apiTypes';
import EditModal from '../../components/EditModal';
import FormArrayField from '../../components/forms/FormArrayField';
import { t } from '../../constants/translations';
import { useAdmin } from '../../contexts/admin.context';
import { useCafe } from '../../contexts/cafe.context';
import { useLocale } from '../../contexts/locale.context';
import { updateDoc } from '../../utils/api';

type Props = {
  open: boolean;
  orderId: string;
  item: OrderItem;
  onClose: () => void;
};

const EditExcises = ({ item, orderId, open, onClose }: Props) => {
  const { lang } = useLocale();
  const { dishesMap } = useCafe();
  const { cafeSlug } = useAdmin();
  const [isLoading, setIsLoading] = useState(false);

  const dish = dishesMap[item.dishId];

  const form = useForm<OrderItem>({
    mode: 'onChange',
    defaultValues: item,
  });

  const { getValues } = form;

  const saveChanges = useCallback(async () => {
    setIsLoading(true);
    const { excises = [] } = getValues();

    await updateDoc<Order>(`cafes/${cafeSlug}/orders/${orderId}`, {
      [`items.${item.id}.excises`]: excises as unknown as FieldValue,
    });

    setIsLoading(false);
    onClose();
  }, [cafeSlug, getValues, item.id, onClose, orderId]);

  return (
    <EditModal<OrderItem>
      title={dish?.name || ''}
      imgUrl={dish?.imageUrl}
      open={open}
      onClose={onClose}
      submitButton={t.save_changes[lang]}
      onSubmit={saveChanges}
      submitButtonProps={{ disabled: !form.formState.isDirty || isLoading }}
      secondaryButton="Не відкриваю пляшок"
      onSecondaryButtonClick={onClose}
      form={form}
      size="xs"
      stopPropagation={false}
    >
      <Box>
        <Typography
          sx={{ display: 'flex', gap: 1, alignItems: 'center', mb: 1 }}
          color={(t) => t.palette.text.secondary}
        >
          <Liquor /> Акцизні макри щойно відкритих пляшок:
        </Typography>
        <FormArrayField
          disabled={isLoading}
          name="excises"
          label="Код акцизної макрки"
          addButtonLabel="відкрити пляшку"
        />
      </Box>
    </EditModal>
  );
};

export default EditExcises;
